import { Field } from 'formik'
import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { UserProfileJobHuntingStatus } from '@/types'
import { CheckboxGroup } from '@/components/organisms/CheckboxGroup'

export const JobHuntingStatusCheckboxField: FC = () => {
  const { t } = useTranslation(['companies-users-[id]'])

  return (
    <CheckboxGroup>
      <label>
        <Field type='checkbox' name='jobHuntingStatus' value={UserProfileJobHuntingStatus.UNKNOWN} />
        {t(UserProfileJobHuntingStatus.UNKNOWN)}
      </label>
      <label>
        <Field type='checkbox' name='jobHuntingStatus' value={UserProfileJobHuntingStatus.ACTIVE} />
        {t(UserProfileJobHuntingStatus.ACTIVE)}
      </label>
      <label>
        <Field
          type='checkbox'
          name='jobHuntingStatus'
          value={UserProfileJobHuntingStatus.INACTIVE_BUT_OPEN_TO_OFFERS}
        />
        {t(UserProfileJobHuntingStatus.INACTIVE_BUT_OPEN_TO_OFFERS)}
      </label>
      <label>
        <Field type='checkbox' name='jobHuntingStatus' value={UserProfileJobHuntingStatus.INACTIVE} />
        {t(UserProfileJobHuntingStatus.INACTIVE)}
      </label>
    </CheckboxGroup>
  )
}
